import { render, staticRenderFns } from "./AssociadoCard.vue?vue&type=template&id=0ec8f859"
import script from "./AssociadoCard.vue?vue&type=script&lang=js"
export * from "./AssociadoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports